import { render, staticRenderFns } from "./thirdRechargeNew.vue?vue&type=template&id=1f32894a&scoped=true&"
import script from "./thirdRechargeNew.vue?vue&type=script&lang=js&"
export * from "./thirdRechargeNew.vue?vue&type=script&lang=js&"
import style0 from "./thirdRechargeNew.vue?vue&type=style&index=0&id=1f32894a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32894a",
  null
  
)

export default component.exports